module.exports = __webpack_public_path__ + "img/login_logo.1704cf3e.png";